const G = "#E6C65C";
const P = "#F3E3B0";
const S = { fill: "none", stroke: G, strokeWidth: 1.7, strokeLinecap: "round", strokeLinejoin: "round" };

const Diya = () => (
  <g {...S}>
    <path d="M24 25 C19 19 22 13 24 7 C26 13 29 19 24 25Z" fill="#E8730C" stroke={P} />
    <path d="M24 22 C22.6 19 23.4 16 24 14 C24.6 16 25.4 19 24 22Z" fill="#FFF6E5" stroke="none" />
    <path d="M7 27 C9 36 37 37 41 27 L45 24 C40 25 37 27 34 27 Z" fill={G} fillOpacity="0.35" />
    <path d="M12 31 C18 33 30 33 36 31" strokeDasharray="1 3" />
    <path d="M15 40 H33" />
  </g>
);

const Dhaak = () => (
  <g {...S}>
    <path d="M24 19 C22 13 18 9 13 7 M24 19 C24 12 27 8 31 5 M24 19 C28 14 33 12 38 11" stroke={P} />
    <ellipse cx="12" cy="29" rx="4" ry="8.5" fill={G} fillOpacity="0.3" />
    <ellipse cx="36" cy="29" rx="4" ry="8.5" fill={G} fillOpacity="0.3" />
    <path d="M12 20.5 H36 M12 37.5 H36" />
    <path d="M16 21 L21 37 M21 21 L26 37 M26 21 L31 37" strokeWidth="1.1" />
    <path d="M40 18 L45 12" />
  </g>
);

const Lotus = () => (
  <g {...S}>
    <path d="M24 11 C29.5 17 29.5 27 24 34 C18.5 27 18.5 17 24 11Z" fill={G} fillOpacity="0.4" />
    <path d="M24 34 C17 32 12 26 11 18 C17 20 21 26 24 34Z" />
    <path d="M24 34 C31 32 36 26 37 18 C31 20 27 26 24 34Z" />
    <path d="M24 34 C16 35 9 32 5 27 C12 25.5 19 29 24 34Z" fill={P} fillOpacity="0.15" />
    <path d="M24 34 C32 35 39 32 43 27 C36 25.5 29 29 24 34Z" fill={P} fillOpacity="0.15" />
    <path d="M13 39 C20 37 28 37 35 39" />
  </g>
);

const Shankha = () => (
  <g {...S}>
    <path d="M11 31 C9 20 18 9 30 9 C38 9 41 17 37 23 C34 28 27 29 22 34 C18 38 13 37 11 31Z" fill={P} fillOpacity="0.3" />
    <path d="M30 9 C34.5 13 34.5 19.5 30.5 21.5 C27 23.5 23 21.5 24 18.5 C25 15.5 28.5 16.5 28 19" />
    <path d="M37 23 L43 27 L38.5 29.5" />
    <path d="M15 33 L9 39" />
    <path d="M16 24 C18 22 20 21 22 21" strokeDasharray="1 2.5" />
  </g>
);

const Alpana = () => (
  <g {...S}>
    {[0, 45, 90, 135, 180, 225, 270, 315].map((a) => (
      <path key={a} d="M24 18 C22 13.5 22 9.5 24 6 C26 9.5 26 13.5 24 18Z" transform={`rotate(${a} 24 24)`} fill={P} fillOpacity="0.2" />
    ))}
    <circle cx="24" cy="24" r="4" fill={G} />
    <circle cx="24" cy="24" r="11" strokeDasharray="1 3" />
  </g>
);

const Dhunuchi = () => (
  <g {...S}>
    <path d="M19 21 C16 17 20 14 18 10 M24.5 21 C22.5 16 27.5 13 24.5 7 M30 21 C28 17.5 31 15.5 30 12" stroke={P} strokeWidth="1.3" />
    <path d="M13 23 H35 C34 30 29.5 33 24 33 C18.5 33 14 30 13 23Z" fill={G} fillOpacity="0.4" />
    <path d="M13 23 L8 20.5" />
    <path d="M21.5 33 L19.5 39 H28.5 L26.5 33" />
    <path d="M16 40 H32" />
  </g>
);

const KashPhool = () => (
  <g {...S}>
    <path d="M24 43 C24 31 21 21 16 11 M24 43 C25 31 28 22 33 12 M24 43 C24 32 24.5 23 25 13" />
    {[[15, 12, -25], [33, 13, 25], [25, 12, 0]].map(([x, y, r]) => (
      <ellipse key={x} cx={x} cy={y} rx="3.2" ry="7" transform={`rotate(${r} ${x} ${y})`} fill="#FFF6E5" fillOpacity="0.55" stroke={P} strokeWidth="1" />
    ))}
    <path d="M17 38 C19 36 21 36 23 37 M31 38 C29 36 27 36 25 37" />
  </g>
);

const Durga = () => (
  <g {...S}>
    <path d="M13 18 L16 8 L20.5 13.5 L24 4 L27.5 13.5 L32 8 L35 18" fill={G} fillOpacity="0.45" />
    <path d="M24 13 C17 13 13 19 13 26 C13 34 18 40 24 40 C30 40 35 34 35 26 C35 19 31 13 24 13Z" fill={P} fillOpacity="0.2" />
    <path d="M16 26 C18 23 21 23 22.5 26 C20.5 28 18 28 16 26Z M25.5 26 C27 23 30 23 32 26 C30 28 27.5 28 25.5 26Z" fill="#FFF6E5" />
    <path d="M24 17.5 C23 19.5 23 21 24 22.5 C25 21 25 19.5 24 17.5Z" fill="#E8730C" stroke="none" />
    <path d="M24 28 V31.5 M21 34.5 C23 35.5 25 35.5 27 34.5" />
  </g>
);

const Trishul = () => (
  <g {...S}>
    <path d="M24 9 V43" />
    <path d="M14 12 C14 22 18 25 24 25 C30 25 34 22 34 12" fill={G} fillOpacity="0.2" />
    <path d="M24 6 L20.5 13 M24 6 L27.5 13 M14 9 L11.5 15 M14 9 L17 14 M34 9 L36.5 15 M34 9 L31 14" />
    <circle cx="24" cy="31" r="2.6" fill={P} />
  </g>
);

const Kalash = () => (
  <g {...S}>
    <path d="M20 19 C16 15 14 13 11 12.5 C13 16 16 18 20 19Z M28 19 C32 15 34 13 37 12.5 C35 16 32 18 28 19Z M24 18 C22.8 14 22.8 10.5 24 8 C25.2 10.5 25.2 14 24 18Z" fill="#1E7040" stroke={P} strokeWidth="1.1" />
    <path d="M18 23 H30 L28 19 H20 Z" />
    <path d="M17 23 C10 29 12 39 24 39 C36 39 38 29 31 23 Z" fill={G} fillOpacity="0.35" />
    <path d="M15.5 31 H32.5" strokeDasharray="1 2.5" />
  </g>
);

const ICONS = [Diya, Dhaak, Lotus, Shankha, Alpana, Dhunuchi, KashPhool, Durga, Trishul, Kalash];
const NAMES = ["diya", "dhaak", "lotus", "shankha", "alpana", "dhunuchi", "kash", "durga", "trishul", "kalash"];
const TONES = [
  ["#7B1E1E", "#3D0D0D"],
  ["#14532D", "#0B2E19"],
  ["#5A1414", "#2C1810"],
];

export const FestiveBadge = ({ index = 0, size = "h-12 w-12" }) => {
  const i = ((index % ICONS.length) + ICONS.length) % ICONS.length;
  const Icon = ICONS[i];
  const [a, b] = TONES[index % TONES.length];
  return (
    <span
      data-testid={`festive-badge-${NAMES[i]}`}
      className={`${size} relative grid shrink-0 place-items-center overflow-hidden rounded-lg`}
      style={{
        background: `radial-gradient(circle at 30% 22%, rgba(230,198,92,0.35), transparent 55%), radial-gradient(circle, rgba(243,227,176,0.22) 0.9px, transparent 1.3px) 0 0 / 6px 6px, linear-gradient(145deg, ${a}, ${b})`,
        boxShadow: "inset 0 0 0 1.5px rgba(230,198,92,0.55), inset 0 0 0 3.5px rgba(0,0,0,0.12)",
      }}
    >
      <svg viewBox="0 0 48 48" className="h-[78%] w-[78%] drop-shadow-[0_1px_1px_rgba(0,0,0,0.35)]" aria-hidden="true">
        <Icon />
      </svg>
    </span>
  );
};
